<template>
    <page-layout :disable-padding="true" :footer-box-shadow="false" class="about-grin-container">
        <template slot="header">
            <div class="ag-header">
                <g-typography tag="h1" font-weight="semibold" :margins="true" value="Who is GRIN?" />
            </div>
        </template>
        <template slot="default">
            <div class="ag-content">
                <g-typography>
                    This creator application is powered by <g-link tag="a" href="https://grin.co">GRIN</g-link> to empower
                    you to create the most authentic content during your collaboration. To learn more about how we keep your data safe, read our
                    <a href="https://grin.co/privacy/">Privacy</a> & <a href="https://grin.co/terms-of-use-influencers/">Terms</a>
                </g-typography>
            </div>
        </template>
        <template slot="footer">
            <div class="ag-footer">
                <powered-by-grin />
            </div>
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../layouts/PageLayout';
    export default {
        name:       'AboutGrinView',
        components: {PageLayout},
    };
</script>

<style lang="scss" scoped>
    .about-grin-container {
        & ::v-deep .ag-header {
            padding: $g-spacing-6 $g-spacing-6 $g-spacing-4;
        }
        & ::v-deep .ag-content {
            padding: 0 $g-spacing-6 $g-spacing-6;
        }
        & ::v-deep .ag-footer {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: $g-spacing-6;
        }
    }
</style>
